<template>
  <button
    class="control-button"
    @click="player.togglePanel(PanelType.PLAYLIST)"
    :aria-label="t('player.controls.playlist')"
    :data-tooltip="t('player.controls.playlist')"
    :aria-expanded="player.activePanel.value === PanelType.PLAYLIST"
    v-html="playlistIcon"
  />
</template>

<script setup lang="ts">
import { playlistIcon } from '../../assets/icons'
import { PanelType } from '../../types'
import { useVideoI18n } from '../../i18n'
import type { UseVideoPlayerReturn } from '../../composables/useVideoPlayer'

defineProps<{
  player: UseVideoPlayerReturn
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
/* Styles are in main.scss */
</style>
